export enum ServiceCode {
    Planning = 'PA',
    BuildingControl = 'BR',
    Enforcement = 'EN',
    PreApps = 'PR'
}
